exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-back[data-v-04768229]{position:absolute;bottom:10px;left:10px;z-index:990;cursor:pointer;user-select:none;-webkit-filter:drop-shadow(1.5px 1.5px 1px #222);filter:drop-shadow(1.5px 1.5px 1px #222)}.button-back.disabled[data-v-04768229]{display:none;pointer-events:none;cursor:default}.button-title[data-v-04768229]{font-family:Nunito;position:absolute;bottom:3px;left:42px;z-index:999;font-size:13px;text-decoration:none;color:#000}@media only screen and (max-width:750px){.button-back[data-v-04768229]{bottom:5px;left:5px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-04768229","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ButtonBack.vue
// module id = 70
// module chunks = 0